const tagName = 'cam-context-switcher-favorite';
import 'custom-event-polyfill';
import starIcon from '../../assets/images/icons/star.svg';

import { eventFavoritesUpdated } from './cam-context-switcher-constants';

const template = require(`../templates/${tagName}.ejs`);

export default class CamContextSwitcherFavorite extends HTMLElement {

  constructor() {
    super();
    this.favoriteData = {
      type: this.dataset.type,
      id: this.dataset.id,
      favorite: typeof(this.dataset.favorite) !== 'undefined',
      icons: {
        star: starIcon
      }
    };

    this.onclick = this.handleClick;
  }

  connectedCallback() {
    this.classList.add(tagName);
    this.innerHTML = template(this.favoriteData);

    if (this.favoriteData.favorite) {
      this.firstChild.classList.add('favorite');
    }
  }

  handleClick(e) {
    e.stopPropagation();

    let eventOptions = {
      detail: {
        context: {
          type: this.favoriteData.type,
          id: this.favoriteData.id
        },
        state: this.favoriteData.favorite ? 'absent' : 'present'
      },
      bubbles: true,
      cancelable: true
    };
    this.dispatchEvent(new CustomEvent(eventFavoritesUpdated, eventOptions));
  }
}

if (!customElements.get(tagName)) {
  customElements.define(tagName, CamContextSwitcherFavorite);
}



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-favorite.js